import React from 'react';

export type TopicVariant =
  | 'pop-culture'
  | 'science-nature'
  | 'history-politics'
  | 'geography-world'
  | 'sports-games'
  | 'leaderboard'
  | 'premium';

/** Hue rotation (deg) per topic – shifts gradient colour while keeping base variables. */
export const TOPIC_HUE_ROTATE: Record<TopicVariant, number> = {
  'pop-culture': 0,
  'science-nature': 100,
  'history-politics': 220,
  'geography-world': 75,
  'sports-games': 25,
  leaderboard: 45,
  premium: 280,
};

interface TopicIllustrationProps {
  variant?: TopicVariant;
  idSuffix: string;
}

/**
 * Topic illustration – gradient background with noise effect.
 * Uses CSS variables for brand colours. Hue modifier per topic for unique colour.
 */
const TopicIllustration: React.FC<TopicIllustrationProps> = ({ variant = 'pop-culture', idSuffix }) => {
  const grad3Id = `topic-grad-3-${idSuffix}`;
  const hueRotate = TOPIC_HUE_ROTATE[variant];

  return (
    <div
      className="topic-illustration"
      aria-hidden
      style={{ '--topic-hue-rotate': `${hueRotate}deg` } as React.CSSProperties}
    >
      <svg
        className="topic-illustration__svg"
        viewBox="0 0 400 200"
        preserveAspectRatio="xMidYMid slice"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <radialGradient id={grad3Id} cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="var(--color-brand-3)" />
            <stop offset="100%" stopColor="var(--color-brand-4)" />
          </radialGradient>
        </defs>
        <rect width="100%" height="100%" fill={`url(#${grad3Id})`} />
      </svg>
    </div>
  );
};

export default TopicIllustration;
